import React from 'react';

type ContextProps = {
  isMobile: boolean,
};

export const ParamsContext = React.createContext<Partial<ContextProps>>({
  isMobile: false,
});
